import { Helpers } from '../../helpers';
import { ISchedule } from '../../interfaces/ischedule';
import { Project } from '../project';
import { Scenario } from '../scenario';
import { ScheduleActivity } from '../schedule-activity';
import { ScheduleBuildSetting } from '../schedule-build-setting';
import { ScheduleRelationship } from '../schedule-relationship';
import { ScheduleTemplateName } from '../schedule-template-name';
import { ScheduleWBSs } from '../schedule-w-b-ss';

export class ScheduleBase {
  ScheduleId: number;
  ScheduleDescription: string;
  Created: Date;
  CreatedByUID: string;
  ScheduleBuildSettingsId: number | null;
  IsTemplate: boolean;
  ScenarioId: number | null;
  ScheduleTemplateNameId: number | null;
  Status: string | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  SentToP6: Date | null;
  ReceivedByP6: Date | null;

  Projects_Schedule?: Array<Project> | null;
  ScheduleActivities_Schedule?: Array<ScheduleActivity> | null;
  ScheduleWBSs_Schedule?: Array<ScheduleWBSs> | null;
  ScheduleRelationships_Scheduleid?: Array<ScheduleRelationship> | null;
  Scenario?: Scenario;
  ScheduleTemplateName?: ScheduleTemplateName;
  ScheduleBuildSetting?: ScheduleBuildSetting;

  constructor(item?: ISchedule) {
    if (item) {

      this.ScheduleId = item.ScheduleId;
      this.ScheduleDescription = item.ScheduleDescription;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedByUID = item.CreatedByUID;
      this.ScheduleBuildSettingsId = item.ScheduleBuildSettingsId;
      this.IsTemplate = item.IsTemplate;
      this.ScenarioId = item.ScenarioId;
      this.ScheduleTemplateNameId = item.ScheduleTemplateNameId;
      this.Status = item.Status;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.SentToP6 = item.SentToP6 ? new Date(item.SentToP6) : null;
      this.ReceivedByP6 = item.ReceivedByP6 ? new Date(item.ReceivedByP6) : null;

      this.Projects_Schedule = Helpers.createClassArray(Project, item.Projects_Schedule);
      this.ScheduleActivities_Schedule = Helpers.createClassArray(ScheduleActivity, item.ScheduleActivities_Schedule);
      this.ScheduleWBSs_Schedule = Helpers.createClassArray(ScheduleWBSs, item.ScheduleWBSs_Schedule);
      this.ScheduleRelationships_Scheduleid = Helpers.createClassArray(ScheduleRelationship, item.ScheduleRelationships_Scheduleid);
      this.Scenario = new Scenario(item.Scenario);
      this.ScheduleTemplateName = new ScheduleTemplateName(item.ScheduleTemplateName);
      this.ScheduleBuildSetting = new ScheduleBuildSetting(item.ScheduleBuildSetting);
    }
  }
}